import { usePlane } from "@react-three/cannon";
import { FLOOR_DIMENSIONS } from "../lib/consts";
import { Suspense, useMemo } from "react";
import * as THREE from "three";
import { useTextures } from "../lib/context/TextureContext";

const TILE_W = 2;
const TILE_H = TILE_W;
const STAGGER = 0;
const COLS = Math.ceil(FLOOR_DIMENSIONS[0] / TILE_W) + 2;
const ROWS = Math.ceil(FLOOR_DIMENSIONS[1] / TILE_H) + 2;

function TileFloorGeo() {
	const geo = useMemo(() => {
		const positions: number[] = [];
		const uvs: number[] = [];
		const indices: number[] = [];
		const halfW = FLOOR_DIMENSIONS[0] / 2;
		const halfL = FLOOR_DIMENSIONS[1] / 2;

		for (let col = 0; col < COLS; col++) {
			const stagger = col * STAGGER;
			const startRow = Math.floor(stagger / TILE_H);
			const x = col * TILE_W - halfW;
			for (let row = startRow; row < startRow + ROWS; row++) {
				const z = -row * TILE_H + halfL + stagger;
				const base = positions.length / 3;
				positions.push(x, 0, z);
				positions.push(x + TILE_W, 0, z);
				positions.push(x + TILE_W, 0, z - TILE_H);
				positions.push(x, 0, z - TILE_H);
				uvs.push(0, 0, 1, 0, 1, 1, 0, 1);
				indices.push(base, base + 1, base + 2, base, base + 2, base + 3);
			}
		}
		const g = new THREE.BufferGeometry();
		g.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
		g.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
		g.setIndex(indices);
		g.computeVertexNormals();
		return g;
	}, []);

	return <primitive object={geo} />;
}

export default function Floor() {
	const { floor: texture } = useTextures();
	const [ref] = usePlane(() => ({
		rotation: [-Math.PI / 2, 0, 0],
		type: "Static",
	}));

	texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
	texture.repeat.set(1, 1);
	texture.offset.set(0, 0);

	return (
		<>
			<mesh ref={ref} rotation={[-Math.PI / 2, 0, 0]} visible={false}>
				<planeGeometry args={FLOOR_DIMENSIONS} />
			</mesh>
			<Suspense fallback={null}>
				<mesh receiveShadow>
					<TileFloorGeo />
					<meshStandardMaterial map={texture} color="#83736c" roughness={0.7} />
				</mesh>
			</Suspense>
		</>
	);
}
